<template>
  <div>

    <!-- Main Row -->
    <div class="row">

      <!-- Form -->
      <div class="col-md-12">
        <Card :title="'Tambah Metode Pembayaran'">
          <template v-slot:body>
            <Form
              :form="form"
              :route="'payment-methods'"
            />
          </template>
        </Card>
      </div>

    </div>

  </div>
</template>

<script>

import Card from "@/view/content/Card.vue";
import Form from '@/component/masters/payment-methods/Form.vue'
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

export default {

  components: {
    Card,
    Form
  },

  data() {
    return {
      form: {
        name: '',
        image: [],
        image_name: '/images/default-payment-method.svg',
        description: ''
      },
    };
  },  

  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Metode Pembayaran", route: "" },
      { title: "Daftar Metode Pembayaran", route: "/masters/payment-methods/list" },
      { title: "Tambah" },
    ])
  },

}

</script>